export const MEDICATION_STATUSES = {
  ACTIVE: 'active',
  DISCONTINUED: 'discontinued',
  INACTIVE: 'inactive',
};



// WEBPACK FOOTER //
// ./src/constants/medicationStatuses.js